import React from 'react';
import { InvoiceForm } from './InvoiceForm';

/**
 * InvoiceFormNew - Wrapper component for creating new invoices
 *
 * Mounted via data-react-component="InvoiceFormNew" in PHP template
 */
const InvoiceFormNew = ({ leadId, jobId, weddingId, contactId, offerId, orderConfirmationId, abschlag, abschlagId, groupId }) => {
    const handleBack = () => {
        window.location.href = 'index.php/invoices';
    };

    return (
        <InvoiceForm
            uuid={null}
            isDraft={false}
            isPreset={false}
            leadId={leadId || null}
            jobId={jobId || null}
            weddingId={weddingId || null}
            contactId={contactId || null}
            offerId={offerId || null}
            orderConfirmationId={orderConfirmationId || null}
            abschlag={abschlag || null}
            abschlagId={abschlagId || null}
            groupId={groupId || null}
            onBack={handleBack}
        />
    );
};

export default InvoiceFormNew;
